import React from 'react';
import PropTypes from 'prop-types';
import isHotkey from 'is-hotkey';

export { MdFormatItalic as ItalicIcon } from 'react-icons/md';

export const ItalicMark = ({ attributes, children }) => (
  <span className="italicMark" {...attributes}>{children}</span>
);

export const ITALIC_MARK_TYPE = 'italic';

ItalicMark.propTypes = {
  children: PropTypes.node,
  attributes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

const italicPlugin = () => ({
  onKeyDown: (event, editor, next) => {
    if (isHotkey('mod+i', event)) {
      event.preventDefault();

      return editor.toggleMark(ITALIC_MARK_TYPE);
    }
    next();
  },
  renderMark: (props, editor, next) => {
    if (props.mark.type === ITALIC_MARK_TYPE) {
      return <ItalicMark {...props} />;
    }
    return next();
  },
  commands: {
    toggleItalic: editor => editor.toggleMark(ITALIC_MARK_TYPE),
  },
  serialize: (node, children) => {
    if (node.type === ITALIC_MARK_TYPE) {
      return <em>{children}</em>;
    }
  },
});

export default italicPlugin;
